module.exports = __webpack_public_path__ + "static/media/course-bg3.9fe35847.svg";